import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLovable = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.0941 10.3041H13.7971V8.84436C13.7971 7.82477 13.3863 6.84694 12.6552 6.12599C11.9241 5.40503 10.9325 5 9.89853 5C8.86458 5 7.87297 5.40503 7.14185 6.12599C6.41074 6.84694 6 7.82477 6 8.84436V18H15.1015C17.2559 18 19 16.2802 19 14.1484C19 12.0167 17.2559 10.2968 15.1015 10.2968L15.0941 10.3041Z",
		fill: "white"
	})
});
export default SvgLovable;
